<template>
<div class="chapter">
<div class="inner_page">
<div class="section level1" id="chapter-11">
<h1>Chapter 11</h1>
<p>Alone on Main Street, James thought a lot about what Cyrus said and how James did want to better himself, so he decided to go to the clinic address on the business card. James turns the street corner onto Bang Avenue, nearly tripping over himself, as he stumbled back after almost bumping into a woman taller and better built than James was. James dropped his hands, as he saw the badge on the officer’s chest and the patch on her sleeve reading, ‘Chronix Bay Police Department.’</p>
<p>“Going somewhere, punk?” the officer, with her arms crossed, says cockily to James.</p>
<p>“I am…uh…just going home,” James lied, shifting his eyes and speaking in a breaking tone.</p>
<p>“Come on, you are coming with me,” says the officer, as she grabbed James by the scruff of his neck and pulls out a pair of handcuffs and slapped them on his wrists behind his back.</p>
<p>“What? I didn’t do anything wrong,” James shouted, struggling in the officer’s grasp.</p>
<p>“Relax,” the officer pointed her finger at James’s face. “Come peacefully, or I will be allowed to use authorized physical force.”</p>
<p>“Am I guilty of something?” James shouted back at the officer.</p>
<p>“Must be something,” the officer snorted, as she shoved James in the direction of the officer’s waiting police cruiser. “You have the right to remain silent, you have the right to an attorney and have him or her with you during questioning, you can stop answering questions at any time if you so desire,” the officer read James his Miranda warnings, as the officer patted James down and slammed his body up against the cruiser. “Do you understand your rights as I read them to you?” the officer asks.</p>
<p>“Uh huh,” James sighed, looking at the officer’s name plate, “Officer Hennessey.”</p>
<p>Officer Hennessey shoved James into the cruiser after opening the door, “Watch your head,” and slammed the car door shut beside James, as the officer yells, “Punk!”</p>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// ch015.vue?fab6bf22